import * as React from "react";
import "./AedasLoading.css";
export default function AedasLoading() {
  return (
    <div style={{display:"flex", justifyContent:"center"}}>
      <div className="lds-dual-ring"></div>
    </div>
  );
}
